import {
   View,
   Text,
   Image,
   StyleSheet,
   ActivityIndicator,
   TouchableOpacity,
   Platform,
   ScrollView,
} from 'react-native';
import React, {useEffect, useState} from 'react';
//import {WebView} from 'react-native-webview';
import WebView from '../../components/webview';
// import { TouchableOpacity } from "react-native-gesture-handler";
import CourseDescriptionHeader from './CourseDescriptionHeader';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
   setIsLandscapemode,
} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector, useDispatch} from 'react-redux';
import {ApplicationHeader} from '../../utils/application_header';
import {Linking} from 'react-native';
import {
   white,
   BROUS,
   DASHBOARD,
   MYTRAINING,
   PROFILE,
   FONT_FAMILY_REGULAR,
   redirectToBrowser,
   CONTACT_US,
   appBackgroundWhiteBG,
   isWindows,
   ActivityLoaderColor,
   primaryColor500,
   BUTTON_HOVER_COLOR,
   BACK_BUTTON_HOVER_COLOR,
   isWeb,
   isiOS,
} from '../../utils/utils';
import Landscap_Application_Header from '../../utils/Landscap_Application_Header';
import {selectAuthData} from '../../redux/slices/AuthSlice';
import {useIsFocused, useNavigation, useRoute} from '@react-navigation/native';
import {RenderHTML} from 'react-native-render-html';
import {setIsPageReload} from '../../redux/slices/ReloadBrowsPageDataSlice';
import {isDesktop} from 'react-device-detect';

const CourseDescriptionScreen = () => {
   const isLandscapemode = useSelector(selectScreenOrientation);
   const authData = useSelector(selectAuthData);
   const [isLoading, setIsLoading] = useState(false);
   const [html, setHtml] = useState('');
   const [hour, setHour] = useState('');
   const [hourLevel, setHourLevel] = useState('');
   const [moduleLevel, setModuleLevel] = useState('');
   const navigation = useNavigation();
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const dispatch = useDispatch();
   const handleLoadEnd = () => {
      setIsLoading(false);
   };
   const item = useRoute().params.item;
   const imageConstant = 'https://cdn.norcat.org/assets/img/catalogue/jpg/';
   //const image = {uri: imageConstant + item.Thumbnail};
   const image = {uri: item.Thumbnail};
   const isIOS = Platform.OS === 'ios';
   const isAndroid = Platform.OS === 'android';
   const isWeb = Platform.OS === 'web';
   const isMobilePlatform = isIOS || isAndroid;
   const isMacos = Platform.OS === 'macos';
   const isModuleCountHoursVisible =
      item.ModuleCount > 0 || item.Duration > 0 ? true : false;

   const [Height, setHeight] = useState(isWeb ? window.innerHeight : 0);
   const isScreenFocused = useIsFocused();
   useEffect(() => {
      if ((isWindows && isScreenFocused) || !isWindows) {
         const fontForDevice = isLandscapemode
            ? !isMobilePlatform
               ? 'font-size:18px;'
               : 'font-size:22px;'
            : 'font-size:44px;';
         if (isIOS) {
            //in iOS fow webview inter font not supported
            setHtml(
               '<div style="color: #585858;' +
                  fontForDevice +
                  'font-family:Helvetica Neue;font-weight:500;font-style: normal,text-transform: capitalize">' +
                  item.Description +
                  '</div>',
            );
         } else if (isAndroid || !isLandscapemode) {
            setHtml(
               '<div style="color: #585858;' +
                  'font-family:Inter;font-weight:500;font-style: normal,text-transform: capitalize">' +
                  item.Description +
                  '</div>',
            );
         } else if (isMacos) {
            setHtml(
               '<div style="color: #585858;' +
                  fontForDevice +
                  'font-family:Helvetica Neue;font-weight:300;font-style: normal,font-size: 14px;line-height: 20px;text-transform: capitalize">' +
                  item.Description +
                  '</div>',
            );
         } else if (isWindows) {
            setHtml(
               '<div style="color: #585858;' +
                  fontForDevice +
                  'font-family:sans-serif;font-weight:300;font-style: normal,font-size: 14px;line-height: 20px;text-transform: none">' +
                  item.Description +
                  '</div>',
            );
         } else {
            setHtml(
               '<div style="color: #585858;' +
                  fontForDevice +
                  'font-family:Inter-Regular;font-weight:500;font-style: normal,text-transform: capitalize">' +
                  item.Description +
                  '</div>',
            );
         }

         setHour(Math.round((item.Duration / 60) * 100) / 100);
         setHourLevel(hour + ' ' + (hour === 1 ? 'Hour' : 'Hours'));
         setModuleLevel(
            item.ModuleCount +
               ' ' +
               (item.ModuleCount === 1 ? ' Module' : ' Modules'),
         );
      }
   }, [hour]);

   useEffect(() => {
      if (isWeb) {
         const resizeWindow = () => {
            const {innerHeight, innerWidth} = window;
            setHeight(innerHeight);
         };
         window.addEventListener('resize', resizeWindow);
         return () => window.removeEventListener('resize', resizeWindow);
      }
   }, [Height, isWeb]);
   return (
      <View
         style={{
            flex: 1,
            backgroundColor: 'white',
            ...Platform.select({
               web: {
                  flex: null,
                  //height: '100vh',
                  height: !isLandscapemode
                     ? isLandscapeSmallWebView
                        ? '100%'
                        : '100vh'
                     : '100vh',
                  minHeight: isLandscapeSmallWebView ? '100vh' : 200,
                  // minHeight: isWeb && isLandscapemode ? 200 : null,
                  minWidth: isWeb && isLandscapemode ? 590 : null,
               },
            }),
         }}>
         {isLandscapemode ? (
            <View style={[styles.viewContainerStyle]}>
               <View>
                  <Landscap_Application_Header
                     authData={authData}
                     selectedTab={BROUS}
                     isProfileScreen={false}
                     onProfileClick={() => {
                        navigation.navigate('ProfileScreen');
                     }}
                     onTopMenuClick={value => {
                        if (value === DASHBOARD) {
                           navigation.navigate('DashboardScreen');
                        } else if (value === MYTRAINING) {
                           navigation.navigate('MyTraningScreen');
                        } else if (value === PROFILE) {
                           navigation.navigate('ProfileScreen');
                        } else if (value === BROUS) {
                           navigation.navigate('BrowsesCoursesScreen');
                        }
                     }}
                     dataSource={['View Profile', 'Edit Profile', 'Logout']}
                  />
               </View>
               <View
                  style={[
                     styles.textContainerStyle,
                     {
                        //height: isLandscapemode ? 96 : null,
                        marginVertical: 24,
                     },
                  ]}>
                  <View
                     style={{
                        flex: isModuleCountHoursVisible ? 0.6 : 1,
                        flexDirection: 'column',
                        justifyContent: isModuleCountHoursVisible
                           ? 'center'
                           : 'flex-start',
                     }}>
                     <Text style={styles.textStyle}>{item.Name}</Text>
                  </View>
                  {isModuleCountHoursVisible && (
                     <View
                        style={{
                           flex: 0.4,
                           flexDirection: 'row',
                           justifyContent: 'flex-end',
                           marginRight: 20,
                        }}>
                        <View
                           style={{flexDirection: 'row', alignItems: 'center'}}>
                           <Image
                              source={require('../../assets/course_hightlight_24.png')}
                              style={{
                                 width: 20,
                                 height: 20,
                                 resizeMode: 'contain',
                              }}
                           />
                           <Text
                              style={{
                                 fontSize: 14,
                                 fontWeight: '600',
                                 fontFamily: FONT_FAMILY_REGULAR,
                                 color: 'white',
                                 marginLeft: 5,
                                 marginRight: 8,
                              }}>
                              {moduleLevel}
                           </Text>
                        </View>

                        <View
                           style={{flexDirection: 'row', alignItems: 'center'}}>
                           <Image
                              source={require('../../assets/Timer.png')}
                              style={{
                                 width: 20,
                                 height: 20,
                                 resizeMode: 'contain',
                              }}
                           />
                           <Text
                              style={{
                                 fontSize: 14,
                                 fontWeight: '600',
                                 fontFamily: FONT_FAMILY_REGULAR,
                                 color: 'white',
                                 marginLeft: 5,
                                 marginRight: 8,
                              }}>
                              {hourLevel}
                           </Text>
                        </View>
                     </View>
                  )}
                  {!isModuleCountHoursVisible && (
                     <View
                        style={{
                           flex: 0.4,
                           flexDirection: 'row',
                           justifyContent: 'flex-end',
                           marginRight: 20,
                        }}>
                        <View
                           style={{flexDirection: 'row', alignItems: 'center'}}>
                           <Text
                              style={{
                                 fontSize: 14,
                                 fontWeight: '600',
                                 fontFamily: FONT_FAMILY_REGULAR,
                                 color: 'white',
                                 marginLeft: 5,
                                 marginRight: 8,
                              }}>
                              {'Practical Training'}
                           </Text>
                        </View>
                     </View>
                  )}
               </View>
            </View>
         ) : null}
         <View
            style={{
               flex: 1,
               flexDirection: isLandscapemode ? 'row-reverse' : 'column',
            }}>
            {!isLandscapemode ? (
               <ApplicationHeader
                  OnBackPress={() => {
                     navigation.goBack();
                  }}
                  title="Course Details"
               />
            ) : null}
            <CourseDescriptionHeader
               image={image}
               courseName={item.Name}
               moduleLevel={moduleLevel}
               hourLevel={hourLevel}
               isModuleCountHoursVisible={isModuleCountHoursVisible}
            />
            <View
               style={{
                  flex: 1,
                  flexDirection: 'column',
               }}>
               {isLoading && (
                  <ActivityIndicator size="large" color={ActivityLoaderColor} />
               )}

               {isLandscapemode ? (
                  <Text
                     style={{
                        marginTop: !isMobilePlatform ? 20 : 40,
                        marginLeft: !isMobilePlatform ? 24 : 26,
                        fontFamily: FONT_FAMILY_REGULAR,
                        fontSize: !isMobilePlatform ? 20 : 25,
                        fontWeight: '600',
                        color: 'black',
                     }}>
                     Course Description
                  </Text>
               ) : null}
               {isAndroid || isWeb ? (
                  <ScrollView
                     style={[
                        styles.webViewStyle,
                        {
                           borderBottomColor:
                              isLandscapemode && !isWeb
                                 ? '#D2D2D2'
                                 : 'transparent',
                           marginLeft: isLandscapemode ? 25 : 20,
                           paddingRight: isLandscapemode ? 25 : 16,
                           marginTop: isLandscapemode ? 14 : 18,
                           borderBottomWidth: isLandscapemode ? 1 : 0,
                           marginBottom:
                              !isMobilePlatform && !isWeb
                                 ? 60
                                 : isLandscapemode
                                 ? 96
                                 : 60,
                        },
                        !isLandscapemode && {
                           ...Platform.select({
                              web: {
                                 paddingBottom: 60,
                              },
                           }),
                        },
                     ]}>
                     <RenderHTML source={{html: html}} scrollEnabled={true} />
                  </ScrollView>
               ) : (
                  <WebView
                     style={[
                        styles.webViewStyle,
                        {
                           borderBottomColor: isLandscapemode
                              ? '#D2D2D2'
                              : 'transparent',
                           marginTop: isLandscapemode ? 14 : 18,
                           borderBottomWidth: isLandscapemode ? 1 : 0,
                           marginBottom: !isMobilePlatform
                              ? 60
                              : isLandscapemode
                              ? 100
                              : 60,
                        },
                        isiOS && {
                           marginLeft: 20,
                           marginRight: 20,
                        },
                     ]}
                     source={{html: html}}
                     onLoadEnd={handleLoadEnd}
                     scrollEnabled={true}
                  />
               )}

               <View
                  style={{
                     position: 'absolute',
                     bottom: 10,
                     left: 0,
                     right: 0,
                     height: !isMobilePlatform
                        ? 60
                        : isLandscapemode
                        ? 100
                        : 50,
                     marginTop: 40,
                     marginHorizontal: 16,
                     ...Platform.select({
                        web: {
                           position: !isLandscapemode
                              ? 'fixed'
                              : Height > 288
                              ? 'absolute'
                              : 'sticky',
                           bottom: 0,
                           backgroundColor: appBackgroundWhiteBG,
                           height: isLandscapemode ? 96 : 72,
                           // minWidth: 384,
                           paddingBottom: isLandscapemode ? 28 : 60,
                           marginTop: 0,
                           paddingTop: isLandscapemode ? 28 : 16,
                           borderTopColor: isLandscapemode
                              ? '#D2D2D2'
                              : 'transparent',
                           borderTopWidth: isLandscapemode ? 1 : 0,
                           marginLeft: isLandscapemode ? 25 : 0,
                           marginRight: isLandscapemode ? 25 : 0,
                        },
                        macos: {
                           bottom: 0,
                           paddingBottom: 22,
                        },
                     }),
                  }}>
                  <ActionBottomButton
                     isLandscapemode={isLandscapemode}
                     onNavigateBack={() => {
                        handleBackButtonAction();
                     }}
                     onButtonPress={onCallBack}
                     IsPurchasable={item.IsPurchasable}
                  />
               </View>
            </View>
         </View>
      </View>
   );
   function handleCallUsAction() {
      if (Platform.OS === 'android' || Platform.OS === 'ios') {
         Linking.openURL('tel:705-521-8324');
      } else {
         redirectToBrowser({url: CONTACT_US});
      }
   }
   function onCallBack(type) {
      const bt = type ? 0 : 1;
      switch (bt) {
         //Purchase
         case 0:
            navigation.navigate('PaymentDetails', {curseData: item});
            break;
         //Request
         case 1:
            handleCallUsAction();
            break;
         //Call
         case 2:
            // handleCallUsAction();
            break;
      }
   }
   function handleBackButtonAction() {
      if (Platform.OS === 'windows') {
         dispatch(setIsPageReload(false));
      }
      navigation.goBack();
   }
};
const ActionBottomButton = props => {
   const [isHover, setHover] = useState(false);
   const [isBackHover, setBackHover] = useState(false);

   const cursePurchaseType = props.IsPurchasable;

   if (props.isLandscapemode) {
      return (
         <View
            style={{
               flex: 1,
               flexDirection: 'row',
               justifyContent: 'flex-end',
               alignItems: 'center',
               paddingTop:
                  Platform.OS !== 'web' ? (isWindows ? null : 21) : null,
            }}>
            <TouchableOpacity
               onMouseEnter={() => {
                  setBackHover(true);
               }}
               onMouseLeave={() => {
                  setBackHover(false);
               }}
               style={[
                  styles.touchableOpacityContainer,
                  {
                     flexDirection: 'column',
                  },
                  {
                     ...Platform.select({
                        web: {
                           paddingRight: 16,
                        },
                     }),
                  },
               ]}
               onPress={() => {
                  props.onNavigateBack();
               }}>
               <View
                  style={[
                     styles.buttonContainerStyle,
                     {
                        backgroundColor: isBackHover
                           ? BACK_BUTTON_HOVER_COLOR
                           : white,
                        paddingHorizontal: 20,
                     },
                     {borderColor: '#003DA5'},
                     {borderWidth: 1},
                  ]}>
                  <Image
                     style={styles.buttonIconStyle}
                     source={require('../../assets/back.png')}
                  />
                  <Text style={[styles.buttonTextStyle, {color: '#003DA5'}]}>
                     Back
                  </Text>
               </View>
            </TouchableOpacity>
            {cursePurchaseType ? (
               <TouchableOpacity
                  style={[
                     styles.touchableOpacityContainer,
                     {
                        ...Platform.select({
                           web: {
                              paddingRight: isDesktop ? 16 : 0,
                           },
                        }),
                     },
                  ]}
                  onPress={() => {
                     props.onButtonPress(cursePurchaseType);
                  }}
                  onMouseEnter={() => {
                     setHover(true);
                  }}
                  onMouseLeave={() => {
                     setHover(false);
                  }}>
                  <View
                     style={[
                        styles.buttonContainerStyle,
                        {
                           paddingHorizontal: 20,
                        },
                        {
                           backgroundColor: isHover
                              ? BUTTON_HOVER_COLOR
                              : primaryColor500,
                        },
                     ]}>
                     <Text style={styles.buttonTextStyle}>Purchase Course</Text>
                  </View>
               </TouchableOpacity>
            ) : (
               <TouchableOpacity
                  onMouseEnter={() => {
                     setHover(true);
                  }}
                  onMouseLeave={() => {
                     setHover(false);
                  }}
                  style={[
                     styles.touchableOpacityContainer,
                     {
                        ...Platform.select({
                           web: {
                              paddingRight: isDesktop ? 16 : 0,
                           },
                        }),
                     },
                  ]}
                  onPress={() => {
                     props.onButtonPress(cursePurchaseType);
                  }}>
                  <View
                     style={[
                        styles.buttonContainerStyle,
                        {
                           backgroundColor: isHover
                              ? BUTTON_HOVER_COLOR
                              : primaryColor500,
                        },
                        {
                           paddingHorizontal: 20,
                        },
                     ]}>
                     <Text style={styles.buttonTextStyle}>
                        Call Us For More Information
                     </Text>
                     <Image
                        style={[
                           styles.buttonIconStyle,
                           {
                              width: 14,
                              height: 20,
                           },
                        ]}
                        source={require('../../assets/callInfo.png')}
                     />
                  </View>
               </TouchableOpacity>
            )}
         </View>
      );
   } else {
      return cursePurchaseType ? (
         <TouchableOpacity
            style={[
               styles.touchableOpacityContainer,
               {
                  marginLeft: 0,
                  paddingRight: 0,
                  flexDirection: props.isLandscapemode ? 'column' : 'row',
               },
               {
                  justifyContent: props.isLandscapemode ? 'flex-end' : 'center',
               },
            ]}
            onPress={() => {
               props.onButtonPress(cursePurchaseType);
            }}>
            <View
               style={[
                  styles.buttonContainerStyle,
                  {
                     // width: Dimensions.get('screen').width - 32,
                     width: props.isLandscapemode
                        ? null
                        : isWeb
                        ? '90%'
                        : '100%',
                     marginHorizontal: 16,
                     justifyContent: 'center',
                  },
               ]}>
               <Text style={[styles.buttonTextStyle]}>Purchase Course</Text>
            </View>
         </TouchableOpacity>
      ) : (
         <TouchableOpacity
            onMouseEnter={() => {
               setHover(true);
            }}
            onMouseLeave={() => {
               setHover(false);
            }}
            style={[
               styles.touchableOpacityContainer,
               {
                  marginLeft: 0,
                  marginRight: 0,
                  paddingRight: 0,
                  flexDirection: props.isLandscapemode ? 'column' : 'row',
               },
               {
                  justifyContent: props.isLandscapemode ? 'flex-end' : 'center',
               },
            ]}
            onPress={() => {
               props.onButtonPress(cursePurchaseType);
            }}>
            <View
               style={[
                  styles.buttonContainerStyle,
                  {
                     backgroundColor: isHover
                        ? BUTTON_HOVER_COLOR
                        : primaryColor500,
                  },
                  {
                     // width: Dimensions.get('screen').width - 320,
                     width: props.isLandscapemode
                        ? null
                        : isWeb
                        ? '90%'
                        : '100%',
                     justifyContent: 'center',
                  },
               ]}>
               <Text style={[styles.buttonTextStyle]}>
                  Call Us For More Information
               </Text>
               <Image
                  style={styles.buttonIconStyle}
                  source={require('../../assets/callInfo.png')}
               />
            </View>
         </TouchableOpacity>
      );
   }
};
const styles = StyleSheet.create({
   webViewStyle: {
      backgroundColor: 'transparent',
      marginLeft: 16,
      marginRight: Platform.OS !== 'web' ? 6 : null,
   },
   touchableOpacityContainer: {
      // flex: 0.8,
      paddingRight: 10,
      paddingTop: Platform.OS === 'windows' ? 15 : null,
   },
   buttonContainerStyle: {
      padding: 10,
      flexDirection: 'row',
      backgroundColor: primaryColor500,
      borderRadius: 6,
      height: 40,
      justifyContent: 'center',
      alignItems: 'center',
   },
   buttonTextStyle: {
      color: 'white',
      fontSize: 14,
      fontWeight: '500',
      fontFamily: FONT_FAMILY_REGULAR,
      marginHorizontal: 10,
   },
   buttonIconStyle: {
      width: 14,
      height: 16,
   },
   viewContainerStyle: {
      backgroundColor: '#001D4E',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
   },
   textContainerStyle: {
      backgroundColor: '#001D4E',
      flexDirection: 'row',
      justifyContent: 'center',
      alignContent: 'center',
   },
   textStyle: {
      marginLeft: 24,
      fontSize: 20,
      fontFamily: FONT_FAMILY_REGULAR,
      fontStyle: 'normal',
      fontWeight: '400',
      color: 'white',
   },
});
export default CourseDescriptionScreen;
